import React, { useRef } from "react";
import Image from "next/image";
import { Link } from "components/Link";
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils";
import type {
  GeneralBynderAsset,
  Hero as HeroType,
  ReducedImage
} from "types/cms";
import { container, desktopContainer, mobileContainer } from "./Hero.css";

export type HeroProps = CMSPageProps & HeroType;

const DesktopImage = ({ imageDesktop, description, title }) => (
  <div className={desktopContainer}>
    <Image
      src={
        (imageDesktop as ReducedImage)?.src ??
        (imageDesktop as GeneralBynderAsset)?.bynderData?.[0]?.thumbnails[
          "OTF BETA"
        ] ??
        "/images/placeholders/2880x1074.svg"
      }
      alt={description}
      title={title || ""}
      width={2880}
      height={1074}
      priority
      style={{
        maxWidth: "100%",
        height: "auto",
        objectFit: "cover"
      }}
    />
  </div>
);

const MobileImage = ({ imageMobile, description, title }) => (
  <div className={mobileContainer}>
    <Image
      src={
        (imageMobile as ReducedImage)?.src ??
        (imageMobile as GeneralBynderAsset)?.bynderData?.[0]?.thumbnails[
          "OTF BETA"
        ] ??
        "/images/placeholders/750x1040.svg"
      }
      alt={description}
      title={title}
      width={750}
      height={1040}
      priority
      style={{
        maxWidth: "100%",
        height: "auto",
        objectFit: "cover"
      }}
    />
  </div>
);

export const Hero: React.FC<HeroProps> = ({
  title,
  description,
  relativeLink,
  imageMobile,
  imageDesktop,
  trackingModule
}) => {
  const ref = useRef(null);

  const handleClick = () => {
    cmsPageClick({
      ...trackingModule,
      moduleContentUrl: relativeLink
    });
  };

  return (
    <div ref={ref} className={container}>
      {relativeLink ? (
        <Link href={relativeLink} onClick={handleClick}>
          <DesktopImage
            imageDesktop={imageDesktop}
            description={description}
            title={title}
          />
          <MobileImage
            imageMobile={imageMobile}
            description={description}
            title={title}
          />
        </Link>
      ) : (
        <>
          <DesktopImage
            imageDesktop={imageDesktop}
            description={description}
            title={title}
          />
          <MobileImage
            imageMobile={imageMobile}
            description={description}
            title={title}
          />
        </>
      )}
    </div>
  );
};
